export interface DefaultAppState {
  collapseSidebar: boolean;
}

export const defaultAppState: DefaultAppState = {
  collapseSidebar: false
};
